<et-navbar></et-navbar>
<div class="max-w-screen-xl px-0 mx-auto sm:px-6">
  <router-outlet></router-outlet>
</div>
